import { Tooltip } from 'bootstrap';

export function enableUnderscores() {
  const enableUnderscores = document.getElementById('enableUnderscores');
  const columnNameInput = document.getElementById('column_name');
  const shortValues = document.querySelectorAll('.new_short_val');

  function updateTooltips() {
    shortValues.forEach(item => {
      // Dispose existing tooltip if any
      if (item._tooltipInstance) {
        item._tooltipInstance.dispose();
      }

      item._tooltipInstance = new Tooltip(item);
    });
  }

  if (enableUnderscores && columnNameInput && shortValues) {
    enableUnderscores.addEventListener('change', function () {
      if (this.checked) {
        shortValues.forEach(item => {
          item.setAttribute('pattern', '[_A-Z0-9\\p{L}\\p{Nd}\\{][A-Z0-9\\p{L}\\p{Nd}\\-_.\\{\\}]*');
          item.setAttribute(
            'title',
            "This value should start from letter or digit or '_' and can have more letters, digits, '-' and '_'"
          );
          item.setAttribute(
            'data-bs-original-title',
            "This value should start from letter or digit or '_' and can have more letters, digits, '-' and '_'"
          );
        });
        columnNameInput.setAttribute('data-cleaning-pattern', '[^ a-zA-Z0-9-_]');
      } else {
        shortValues.forEach(item => {
          item.setAttribute('pattern', '[A-Z0-9\\p{L}\\p{Nd}\\{][A-Z0-9\\p{L}\\p{Nd}\\-_.\\{\\}]*');
          item.setAttribute(
            'title',
            "This value should start from letter or digit and can have more letters, digits, '-' and '_'"
          );
          item.setAttribute(
            'data-bs-original-title',
            "This value should start from letter or digit and can have more letters, digits, '-' and '_'"
          );
        });
        columnNameInput.setAttribute('data-cleaning-pattern', '[^ a-zA-Z0-9-]');
        columnNameInput.value = columnNameInput.value.replace(/_/g, '');
        shortValues.forEach(item => {
          item.value = item.value.replace(/^_+/, '');
        });
      }

      setTimeout(() => {
        updateTooltips();
      }, 300);
    });
  }
}
